export default [
    { id: 'editorial', name: 'Editorial' },
    { id: 'global', name: 'Global' },
];
